//
import React, { useEffect, useState } from 'react';
import { Dialog, Paragraph, Portal, Title } from 'react-native-paper';
import colors from '../../colors';
import { TXT_M, TXT_P, TXT_PP, MAX_WIDTH_MODAL } from '../../constants';
import { useSessaoOnly } from '../../redux/sessao/sessaoHooks';
import CModal from './CModal';
import CTextInput from './CTextInput';
import Button from '../Generic/Button';
import { StyleSheet, View, Text, ActivityIndicator } from 'react-native';
import clienteApi from '../../apis/clienteApi';
import { celularMask } from '../../shared/helper';
import { Alert } from 'react-native';

type Props = {};

const CadastrarCelularDialog: React.FC<Props> = (props) => {
  const [open, setOpen] = useState(false);

  const [sessao, revalidate] = useSessaoOnly();

  const [loading, setLoading] = useState(false);
  const [celular, setCelular] = useState('');

  const updateCelular = async () => {
    setLoading(true);
    try {
      const novoCel = celular.replace(/\D/g, '');
      await clienteApi.updateCelular(novoCel);
      await revalidate();
    } catch (err) {
      console.log('Erro');
      Alert.alert('Erro', err.data ?? 'Erro ao cadastrar comanda.');
    }
    setLoading(false);
  };

  useEffect(() => {
    console.log('sessao?.cliente', sessao?.cliente);

    if (sessao?.cliente && !sessao.cliente.celular) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [sessao?.cliente?.celular]);

  if (loading) {
    return (
      <CModal mostrarModal={open} onClose={() => {}} style={{ padding: 20 }}>
        <ActivityIndicator size={50} color={colors.primary} />
      </CModal>
    );
  }

  return (
    <CModal mostrarModal={open} onClose={() => {}}>
      <Dialog.Content>
        <Title>Cadastre seu Celular</Title>
        <Paragraph style={{ marginBottom: 20 }}>
          Você precisa cadastrar seu celular para continuar a utilizar nossa plataforma.
        </Paragraph>

        <CTextInput
          label={'Celular'}
          maxLength={16}
          placeholder={'(99) 9 9999-9999'}
          onChangeText={(txt) => {
            txt = celularMask(txt);
            setCelular(txt);
          }}
          value={celular}
          style={styles.input}
        />

        <Button title="Cadastrar" onPress={() => updateCelular()} />
      </Dialog.Content>
      {/* <Dialog.Actions style={{ justifyContent: 'space-around' }}></Dialog.Actions> */}
    </CModal>
  );
};

const styles = StyleSheet.create({
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  }
});

export default CadastrarCelularDialog;
